import Coins from "./Coins";
export default Coins;
